import ExpandablePageSection from "./expandablePageSection";

export default ExpandablePageSection;
